<template>
  <v-dialog v-model="dialog" persistent width="100%">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>remove_red_eye</v-icon>Ver detalle programación
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12>
            <v-container
              grid-list-md
              class="py-0 px-3"
              style="min-width: 100%;"
            >
              <v-flex xs12>
                <h4>
                  <strong>SERVIDOR PÚBLICO: </strong
                  >{{ this.form.servidor_publico }}
                </h4>
              </v-flex>
              <v-layout>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="lista_funcionarios_vacaciones"
                    class="elevation-2"
                    no-data-text="Sin datos"
                  >
                    <!-- Cabecera -->
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on" class="letra-cabecera">
                            {{ props.header.text }}
                          </span>
                        </template>
                        <span>
                          {{ props.header.text }}
                        </span>
                      </v-tooltip>
                    </template>
                    <template v-slot:items="items">
                      <td class="text-xs-center" id="sin_margen">
                        {{ items.item.servidor_publico }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          $moment(
                            items.item.fecha_incorporacion,
                            "YYYY-MM-DD"
                          ).format("DD/MM/YYYY")
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_saldo_a }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_saldo_b }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_saldo_c }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.total_dias_saldo }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_programar }}
                      </td>
                      <td class="text-xs-center">
                        {{ items.item.dias_no_programados }}
                      </td>
                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[0]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[1]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[2]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[3]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[4]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[5]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[6]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[7]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[8]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[9]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[10]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td id="sin_margen">
                        <tr>
                          <th class="cabecera2">INICIO</th>
                          <th class="cabecera2">FIN</th>
                        </tr>
                        <tr
                          v-for="programacion in items.item.vector_meses[11]"
                          :key="programacion.id"
                        >
                          <td id="celda_especial">
                            {{ programacion.fecha_desde }}
                          </td>
                          <td id="celda_especial">
                            {{ programacion.fecha_hasta }}
                          </td>
                        </tr>
                      </td>

                      <td class="text-xs-center" id="sin_margen">
                        {{ items.item.estado }}
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cerrrar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      form: {},
      lista_funcionarios_vacaciones: [],
      gestion: parseInt(this.$route.params.gestion),
      unidad: this.$storage.get("user").unidad[0]
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Servidor público",
          value: "id",
          align: "center",
          class: "celda2"
        },
        {
          text: "Fecha de incorporación",
          value: "fecha_solicitud",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 3}-${this.gestion -
            2}\n(A)`,
          value: "dias_saldo_a",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 2}-${this.gestion -
            1}\n(B)`,
          value: "dias_saldo_b",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 1}-${
            this.gestion
          }\n(C)`,
          value: "dias_saldo_c",
          align: "center",
          class: "celda2"
        },
        {
          text: `TOTAL DIAS\n(A+B+C)`,
          value: "total_dias_saldo",
          align: "center",
          class: "celda2"
        },
        {
          text: `TOTAL DIAS PROGRAMADOS DE ACUERDO A PORCENTAJE`,
          value: "dias_programar",
          align: "center",
          class: "celda2"
        },
        {
          text: `TOTAL DIAS NO PROGRAMADOS`,
          value: "dias_no_programados",
          align: "center",
          class: "celda2"
        },
        { text: "Ene", value: "", align: "center", class: "celda2" },
        { text: "Feb", value: "", align: "center", class: "celda2" },
        { text: "Mar", value: "", align: "center", class: "celda2" },
        { text: "Abr", value: "", align: "center", class: "celda2" },
        { text: "May", value: "", align: "center", class: "celda2" },
        { text: "Jun", value: "", align: "center", class: "celda2" },
        { text: "Jul", value: "", align: "center", class: "celda2" },
        { text: "Ago", value: "", align: "center", class: "celda2" },
        { text: "Sep", value: "", align: "center", class: "celda2" },
        { text: "Oct", value: "", align: "center", class: "celda2" },
        { text: "Nov", value: "", align: "center", class: "celda2" },
        { text: "Dic", value: "", align: "center", class: "celda2" },
        { text: "Estado", value: "estado", align: "center", class: "celda2" }
      ];
    }
  },
  mounted() {
    this.$bus.$on("openDialogVerDetalleSolicitudesProgramacion", async item => {
      this.form = item;
      await this.cargarProgramaciones();
      (item.mes_enero = [
        {
          id: 1,
          fecha_inicio: "2022-01-01",
          fecha_fin: "2022-01-01"
        },
        {
          id: 2,
          fecha_inicio: "2022-01-01",
          fecha_fin: "2022-01-01"
        },
        {
          id: 3,
          fecha_inicio: "2022-01-01",
          fecha_fin: "2022-01-01"
        }
      ]),
        this.lista_funcionarios_vacaciones.push(item);
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cargar el detalle de las programaciones
    async cargarProgramaciones() {
      let res;
      try {
        let usuario = this.$storage.get("user").id_persona;
        let vec_meses = [];
        let mayor_cantidad_registros = 1;
        for (let index = 0; index < 12; index++) {
          vec_meses.push([]);
        }
        res = await this.$service
          .graphql({
            query: `
            query{
            vVacaProgramadas(id_persona:${this.form.id_persona},restriccion_estados:"9,47",periodo:${this.gestion}){
              count
              rows{
                id
                fecha_desde
                fecha_hasta
                id_estado
                fecha_solicitud
                id_unidad
                total_dias
                estado
                id_persona
                periodo
              }
            }
          }
          `
          })
          .then(response => {
            if (response) {
              let listado_programaciones = response.vVacaProgramadas.rows;

              listado_programaciones.forEach(element => {
                let mes_ini = parseInt(
                  this.$moment(element.fecha_desde, "DD/MM/YYYY").format("M")
                );
                let mes_fin = parseInt(
                  this.$moment(element.fecha_hasta, "DD/MM/YYYY").format("M")
                );
                if (mes_ini == mes_fin) {
                  vec_meses[mes_ini - 1].push(element);
                } else {
                  vec_meses[mes_ini - 1].push(element);
                  if (
                    this.$moment(element.fecha_hasta, "DD/MM/YYYY").format(
                      "YYYY"
                    ) == this.gestion
                  ) {
                    vec_meses[mes_fin - 1].push(element);
                  }
                }
              });

              vec_meses.forEach(element => {
                if (element.length > mayor_cantidad_registros) {
                  mayor_cantidad_registros = element.length;
                }
              });
              let contador = -1;
              for (let index2 = 0; index2 < vec_meses.length; index2++) {
                const element = vec_meses[index2];
                if (element.length < mayor_cantidad_registros) {
                  for (
                    let index = element.length;
                    index < mayor_cantidad_registros;
                    index++
                  ) {
                    element.push({
                      id: contador,
                      fecha_desde: "-",
                      fecha_hasta: "-"
                    });
                    contador = contador - 1;
                  }
                }
              }
              this.form.vector_meses = vec_meses;
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.valid = false;
      this.lista_funcionarios_vacaciones = [];
      this.$bus.$emit("closeDialogVerDetallesProg");
      this.dialog = false;
    }
  }
};
</script>

<style scoped lang="scss">
h4 {
  color: rgb(1, 3, 85);
}
.cabecera {
  white-space: pre;
  word-wrap: break-word;
  background: rgba(0, 165, 151, 0.438);
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: solid 0.0001em;
}
.cabecera2 {
  font-family: Helvetica;
  font-size: 0.9em;
  word-wrap: break-word;
  background: rgba(0, 165, 151, 0.438);
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: solid 0.0001em rgba(65, 144, 150, 0.589);
}
#celda_especial {
  background: rgba(204, 250, 246, 0.281);
  white-space: nowrap;
  padding: 0em 0.5em 0em 0.5em;
  text-align: center;
}
#sin_margen {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: 0em 0em 0em 0em;
}
#sin_margen2 {
  margin: 0em 0em 0em 0em;
  padding: 0em 1em 0em 1em;
  width: 100%;
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/VerDetalleSolicitudesProgramacion.vue